import { ToolService } from 'app/core/services/tool.service';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ToolDatamatrix } from "@app/tool/model/toolDatamatrix.model";
import { Log } from "ng2-logger";
import { TranslateParser, TranslateService } from "@ngx-translate/core";
import { ToastsManager } from "@app/shared/util/toastr.service";

@Component({
    selector: 'app-tool-engrave',
    templateUrl: './tool-engrave.component.html',
    styleUrls: ['./tool-engrave.component.scss']
})
export class ToolEngraveComponent implements OnInit {
    _logger = Log.create(ToolEngraveComponent.name);

    @Input() isScanListenerActive = false;
    allToolsEngraved = false;

    focused = true;

    _toolsToScan: ToolDatamatrix[];

    constructor(private toolService: ToolService,
                private translateService: TranslateService,
                private translateParser: TranslateParser,
                private toastr: ToastsManager) {
    }

    @HostListener('window:focus', ['$event'])
    onFocus() {
        this.focused = true;
    }

    @HostListener('window:blur', ['$event'])
    onBlur() {
        this.focused = false;
    }

    ngOnInit() {
    }

    onToolEngravedCodeScan(engravedScanCode) {
        this._logger.info('onToolEngravedCodeScan:: Calling engreaving validation with scanned code', engravedScanCode);
        const engravedTool = this.toolsToScan.find(tool => engravedScanCode.indexOf(tool.engravedCode) !== -1);

        if (!engravedTool) {
            this._logger.error('onToolEngravedCodeScan::Invalid engraved code', engravedScanCode);
            this.toastr.error(this.buildEngravedErrorMessage(engravedScanCode));
            return;
        }

        this.toolService.confirmToolEngrave(engravedTool).subscribe(
            (data) => {
                this._logger.info('API responded with data', data);
                this.toastr.success(this.buildEngravedMessage(engravedTool.engravedCode));
                this.markEngraved(engravedTool.engravedCode);
            }, (error) => {
                this._logger.error('API responded with error', error);
            });
    }

    private markEngraved(toolUID) {
        this._logger.info("markEngraved:: Markign tool as engraved", toolUID);
        const engravedTool = this.toolsToScan.find(tool => tool.engravedCode === toolUID);
        if (engravedTool) {
            engravedTool.isEngraved = true;
        }
        this.checkAllEngraved();
    }

    private checkAllEngraved() {
        let allEngraved = true;
        if (!this.toolsToScan) {
            allEngraved = false;
        } else {
            this.toolsToScan.forEach(tool => {
                if (!tool.isEngraved) {
                    allEngraved = false;
                }
            });
        }

        this.allToolsEngraved = allEngraved;
    }


    get toolsToScan() {
        return this._toolsToScan;
    }

    @Input()
    set toolsToScan(toolsToScan) {
        this._toolsToScan = toolsToScan;
        this.checkAllEngraved();
    }

    buildEngravedMessage(toolName) {
        const message = this.translateService.instant('admin.tools.toasts.engraved');
        return this.translateParser.interpolate(message, {toolName: toolName});
    }

    buildEngravedErrorMessage(scannedCode) {
        const message = this.translateService.instant('admin.tools.toasts.errorEngraved');
        return this.translateParser.interpolate(message, {scannedCode: scannedCode});
    }
}
